import SimpleEditor from './SimpleEditor';

export default SimpleEditor;
